import { state } from '../state';
import { h } from '../ui';

export const STATIC_PAGES = ['credits', 'impressum', 'datenschutz'];

export async function renderStaticPage(root: HTMLElement, page: string): Promise<void> {
  const back = h('a', { class: 'btn back-link', href: '#/' }, state.user ? '← Zurück zum Kalender' : '← Zurück zur Anmeldung');
  const content = h('article', { class: 'static-page' }, h('p', { class: 'muted' }, 'Lade …'));
  root.append(h('div', { class: 'static-wrap' }, back, content));
  try {
    const res = await fetch(`/pages/${page}.html`);
    if (!res.ok) throw new Error(String(res.status));
    content.innerHTML = await res.text(); // eigener, vertrauenswürdiger Inhalt aus public/pages
  } catch {
    content.textContent = 'Die Seite konnte nicht geladen werden.';
  }
}
